var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-width-expand@m"},[_c('div',{staticClass:"bb-options",class:{'active' : _vm.modals_open}},[(_vm.popular_finishes.length > 0)?_c('MostPopular'):_vm._e(),_c('CreateOwn',{on:{"toggle":_vm.onToggleVisibility}})],1),_c('NextButtons',{attrs:{"prev_route":"choose-size","next_route":"additions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }